import React, { Component } from 'react'

export default class extends Component {
  render() {
    return (
      <img
        style={{
          position: 'absolute',
          width: '100%',
          zIndex: 20,
          top: 0,
          left: 0
        }}
        src="//qnm.hunliji.com/o_1dnc75be61eb04tc1k4l1g5j4bnb.png"
      />
    )
  }
}
